// import { cssdApiClients, cssdApiClients, cssdApiClients } from "../../../http-common";
// import authHeader from "../../../authentication/authservices/auth-header";

import { cssdApiClients } from "../../../http-common";

import authHeader from "../../../authentication/authservices/auth-header";

export const fetchMachineWiseCycleDetailsList = async (listObj) => {
  return await cssdApiClients.post("/cssdtransfer/machinewisecssdcycle", listObj, {
    headers: authHeader(),
  });
};

export const fetchKitWiseCycleDetailsList = async (listObj) => {
  return await cssdApiClients.post("/cssdtransfer/kitwisecssdcycle", listObj, {
    headers: authHeader(),
  });
};

export const fetchStockReportList = async (listObj) => {
  return await cssdApiClients.post("/cssd/getStockReport", listObj, {
    headers: {
      ...authHeader(),
      "Content-Type": "application/json",
    },
  });
};

// export const printCssdCycleBarcode = (lotNo, preview) => {
//   return reportsApi.get(`/generatePdf/cssdBarCode?lotNo=${lotNo}`, {
//     responseType: preview === false ? "arraybuffer" : "blob",
//     headers: authHeader(),
//   });
// };